import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import TextField from "@material-ui/core/TextField/index";
import { Button } from "react-bootstrap";
import ReactSelect from "../../UI/ReactSelectNotClear";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";

export default function Filter(props) {
  const { onHide, show, filterInputsUpdate, filterInputs, setFilterInputs, deviceId, devicePlaceId,operation } = props;
  const [chooseOption, setChooseOption] = useState([]);
  const [chooseDeviceOption, setChooseDeviceOption] = useState([]);
  const [chooseOperationOption, setChooseOperationOption] = useState([]);


  function handleChangePlace(value) {
    setChooseOption(value);
    filterInputsUpdate("devicePlaceId", value.value);

  }
  function handleChangeDevice(value) {
    setChooseDeviceOption(value);
    filterInputsUpdate("deviceId", value.value);

  }
  function handleChangeOperation(value) {
    setChooseOperationOption(value);
    filterInputsUpdate("operation", value.value);

  }
  var date = new Date();
  
  const onResetFilter = () => {
    setFilterInputs({
      ip:"",
      start: new Date(
        new Date(date.getFullYear(), date.getMonth(), 1, 0, 0, 0, 0) -
        new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .split("T").join(" ").split(".")[0],
  
  
      end: new Date(
        new Date(date.getFullYear(), date.getMonth() + 1, 0, 23, 59, 59, 999) - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .split("T").join(" ").split(".")[0],
    });
    setChooseDeviceOption(null);
    setChooseOption(null);
    setChooseOperationOption(null);
    onHide(false)
  }

  const [open, setOpen] = React.useState(false);

  function handleClose() {
    setOpen(false);
  }

  function handleOpens() {
    setOpen(true);
  }


  return (
    <Modal
      size="md"
      show={show}
      onHide={onHide}
      aria-labelledby="create"
      centered
      className="modal pr-0"
    >
      <Modal.Header closeButton>
        <Modal.Title id="create"> Qurğu əməliyyatları hesabatı filtri</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="col-12 pl-4 pr-4">
          <div className="row">
            <div className="col-12 col-md-12 col-lg-12">
              <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                <TextField
                  id="ip"
                  name="ip"
                  label="Ip"
                  placeholder="Ip "
                  className="w-100"
                  value={filterInputs.ip}
                  onChange={(e) =>
                    filterInputsUpdate("ip", e.target.value)
                  }
                // onChange={(e) => filterInputsUpdate(e)}
                />
              </div>
            </div>


            <div className="col-12 col-md-12 col-lg-12">
              <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
             
                  <ReactSelect
                  suggestions={operation}
                  handleChangeSingle={(value) => handleChangeOperation(value)}
                  single={chooseOperationOption}
                  label="Əməliyyat  seçin"
                  placeholder="Əməliyyat seçin"
                  inputId="operation"
                />
              </div>
            </div>

       
            <div className="col-12 col-md-12 col-lg-12">
              <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                <ReactSelect
                  suggestions={devicePlaceId}
                  handleChangeSingle={(value) => handleChangePlace(value)}
                  single={chooseOption}
                  label="Qurğu məkanı  seçin"
                  placeholder="Qurğu məkanı seçin"
                  inputId="devicePlaceId"
                />
              </div>
            </div>
            <div className="col-12 col-md-12 col-lg-12">
              <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                <ReactSelect
                  suggestions={deviceId}
                  handleChangeSingle={(value) => handleChangeDevice(value)}
                  single={chooseDeviceOption}
                  label="Qurğu seçin"
                  placeholder="Qurğu seçin"
                  inputId="deviceId"
                />
              </div>
            </div>
            <div className="col-12 col-md-12 col-lg-12">
              <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                <FormControl className="w-100">
                  <InputLabel htmlFor="status">Vəziyyət </InputLabel>
                  <Select
                    open={open}
                    onClose={handleClose}
                    onOpen={handleOpens}
                    value={filterInputs.status ? filterInputs.status : ""}
                    onChange={(e) =>
                      filterInputsUpdate("status", e.target.value)
                    }
                    inputProps={{
                      name: "status",
                      id: "status",
                    }}
                  >
                    <MenuItem value="SUCCESS">Success</MenuItem>
                    <MenuItem value="ERROR">Error</MenuItem>

                  </Select>
                </FormControl>
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-end">
            <Button
              variant="primary"
              onClick={() => {
                onResetFilter();
              }}
              className="mt-4"
            >
              Sıfırla
            </Button>
            <Button
              variant="success"
              onClick={() => {
                onHide(false);
              }}
              className="mt-4 ml-4"
            >
              Tamam
            </Button></div>

        </div>
      </Modal.Body>
    </Modal>
  );
}
